import { environment } from '../../environments/environment';

export function GetSelect2FileTagsOptions() {
    return {
        placeholder: "Select some tags",
        multiple: true,
        width: "100%",
        ajax: {
            url: environment.apiBasePath + 'tags/list?page=1&limit=50',
            data: function (term, page) {
                return {searchText: term};
            },
            results: function (data, page) {
                return {results: data.tags};
            }
        },
        initSelection: () => {
        },
        id: function (tag) {
            return tag.id;
        },
        formatResult: function (tag) {
            return '<span class="file-tag-box" style="background:' + tag.tagColour + '"><span style="color:' + tag.tagTextColour + '">' + tag.description + '</span></span>';
        },
        formatSelection: function (tag) {
            return '<span class="file-tag-box" style="background:' + tag.tagColour + '"><span style="color:' + tag.tagTextColour + '">' + tag.description + '</span></span>';
        },
    };
}
